import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { type SelfDescribingJson, setUserId } from '@snowplow/browser-tracker'

/**
 * Identity returned by guest checkout, kept only for Snowplow.
 * This does not create an auth session.
 */
interface GuestSnowplowUser {
  accountId: string
  email: string
  firstName?: string
}

let guestUser: GuestSnowplowUser | undefined

export function attachGuestUserContext(user: Partial<GuestSnowplowUser>): void {
  const accountId = user.accountId?.trim()
  const email = user.email?.trim()
  if (!accountId || !email) return

  guestUser = {
    accountId,
    email,
    firstName: user.firstName?.trim() || undefined,
  }
  setUserId(accountId)
}

export function detachGuestUserContext(): void {
  if (!guestUser) return

  guestUser = undefined
  setUserId(undefined)
}

export function guestUserContexts(): Array<SelfDescribingJson> {
  if (!guestUser) return []

  return [
    comluxgroup.createUser_1_0_1({
      id: guestUser.accountId,
      email: guestUser.email,
      first_name: guestUser.firstName,
      is_spoofed: false,
      account_type: 'guest',
    }),
    comluxgroup.createUserPurchaseCount_1_0_0({
      number_of_purchases: 0,
    }),
  ]
}
